// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Taq6","col":"styles_col__1o8Ob"};